import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=adaaae8e"
import script from "./marketing.vue?vue&type=script&lang=ts"
export * from "./marketing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adaaae8e')) {
      api.createRecord('adaaae8e', component.options)
    } else {
      api.reload('adaaae8e', component.options)
    }
    module.hot.accept("./marketing.vue?vue&type=template&id=adaaae8e", function () {
      api.rerender('adaaae8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/marketing.vue"
export default component.exports